// src/components/support/SupportChatButton.tsx

import React from 'react';
import { MessageCircle } from 'lucide-react';

interface SupportChatButtonProps {
  onClick: () => void;
  unreadCount?: number;
}

export const SupportChatButton: React.FC<SupportChatButtonProps> = ({
  onClick,
  unreadCount = 0,
}) => {
  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 z-40 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-4 shadow-lg transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-4 focus:ring-blue-300 sm:bottom-4 sm:right-4 sm:p-3"
      aria-label="Open support chat"
    >
      <MessageCircle className="w-6 h-6 sm:w-5 sm:h-5" />
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  );
};
